import React from 'react';
import { Link } from 'react-router-dom';
import "./Header.css";

function Header() {
  return (
    <div className="top-nav">
      <div className="nav-toggle">Paalyam Admin Panel</div>
      <div className="navlist">
        <ul>
          <li><Link to="/admin/oldresurveylist">Old Survey List</Link></li>
          <li><Link to="/admin/newresurveylist">New Survey List</Link></li>
          <li><Link to="/admin/alllist">All List</Link></li>
        </ul>
      </div>
    </div>
  );
}

export default Header;